import Swiper from 'swiper';
import 'swiper/css';
import { Mousewheel, Keyboard } from 'swiper/modules';

const swiperSections = document.querySelectorAll('section.cards .swiper');

if (swiperSections.length) {
  swiperSections.forEach(swiperContainer => {
    const alwaysEnableSwiper = swiperContainer.classList.contains('force-swiper');
    const breakpoint = window.matchMedia('(min-width: 1100px)');
    let swiperInstance = null;

    const enableSwiper = () => {
      if (!swiperInstance) {
        swiperInstance = new Swiper(swiperContainer, {
          modules: [Mousewheel, Keyboard],
          direction: 'horizontal',
          spaceBetween: 15,
          slidesPerView: 1.2,
          slidesOffsetAfter: 40,

          mousewheel: {
            forceToAxis: true,
            sensitivity: 1,
          },

          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },

          breakpoints: {
            600: {
              slidesPerView: 1.5,
              spaceBetween: 25,
            },
            700: {
              slidesPerView: 1.7,
            },
            800: {
              slidesPerView: 2.2,
            },
            1180: {
              slidesPerView: 3.2,
              spaceBetween: 20,
            },
            // 1450: {
            //   slidesPerView: 'auto',
            //   spaceBetween: 30,
            // },
          },
        });
      }
    };

    const destroySwiper = () => {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    };

    const toggleSwiper = () => {
      if (alwaysEnableSwiper) {
        enableSwiper();
      } else {
        if (breakpoint.matches) {
          destroySwiper();
        } else {
          enableSwiper();
        }
      }
    };

    toggleSwiper();
    breakpoint.addEventListener('change', toggleSwiper);
  });
}